// extracted by mini-css-extract-plugin
export default {"Main":"PcCategory_Main__+bqGt","Shop":"PcCategory_Shop__01+0C"};